import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Description } from '../../../models/description';

@Injectable({
  providedIn: 'root'
})
export class DescriptionService {

  private endpointPrefix = environment.apiUrl;
    
    constructor(private http: HttpClient) {}
    
    public createDescription(payload: any) {
      return this.http.post(`${this.endpointPrefix}/descriptions`, payload);
    }
  
    public getDescriptionsByInstance(id: number){
      return this.http.get<Description[]>(`${this.endpointPrefix}/instances/${id}/descriptions`);
    }

    public getDescriptionById(id: number){
      return this.http.get<Description>(`${this.endpointPrefix}/descriptions/${id}`);
    }
  
    public updateDescription(id: number, payload: any) {
      return this.http.patch(`${this.endpointPrefix}/descriptions/${id}`,payload);
    }
  
    public deleteDescriptions(descriptions: Description []) {
      return this.http.delete(`${this.endpointPrefix}/descriptions/delete-any`, {body: descriptions});
    }

    public exportDescriptions(ids: number[]){
      return this.http.post(`${this.endpointPrefix}/descriptions/export`, {ids},{ responseType: 'blob' });
    }

    public importDescriptions(payload: any){
      return this.http.post(`${this.endpointPrefix}/descriptions/import`, payload, { reportProgress: true,  observe: 'events', });
    }
}
